import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {NavigationEvent} from '@spartacus/storefront';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, map, tap} from 'rxjs/operators';
import {ErrorPageEvent} from './error-page-event';
import {Observable} from 'rxjs';
import {DcpEddlDispatchService} from '../dcp-eddl-dispatch-beacon.service';

const SEMANTIC_CONFIGURATOR_ERROR_DEFAULT = 'configuratorErrorDefault';
const SEMANTIC_CONFIGURATOR_ERROR = 'configuratorError';

const SEMANTIC_ERROR_PAGES = [SEMANTIC_CONFIGURATOR_ERROR, SEMANTIC_CONFIGURATOR_ERROR_DEFAULT];

const CONFIGURATOR_PAGE_SECTION = 'configurator';
const DEFAULT_CONFIGURATOR_ERROR_DESCRIPTION = 'Generic error for the configurator Page.';
const DEFAULT_CONFIGURATOR_ERROR_TYPE = 'configuratorError';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ErrorPageEventService {
  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    protected eventService: EventService,
    protected dispatchService: DcpEddlDispatchService
  ) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.eventService.register(ErrorPageEvent, this.buildErrorPageEvent());
  }

  protected buildErrorPageEvent(): Observable<ErrorPageEvent> {
    return this.eventService.get(NavigationEvent).pipe(
      untilDestroyed(this),
      filter((navigationEvent) => this.isSemanticRouteInErrorList(navigationEvent.semanticRoute, SEMANTIC_ERROR_PAGES)),
      tap(() => {
        this.dispatchService.dispatchAfterPageViewEvent();
      }),
      map((navigationEvent) => {
        const errorEvent = {} as ErrorPageEvent;
        errorEvent.navigation = navigationEvent;
        switch (navigationEvent.semanticRoute) {
          case SEMANTIC_CONFIGURATOR_ERROR:
            errorEvent.errorType = navigationEvent.params.errorCode;
            errorEvent.description = navigationEvent.params.errorCode;
            errorEvent.pageSection = CONFIGURATOR_PAGE_SECTION;
            break;
          case SEMANTIC_CONFIGURATOR_ERROR_DEFAULT:
            errorEvent.errorType = DEFAULT_CONFIGURATOR_ERROR_TYPE;
            errorEvent.description = DEFAULT_CONFIGURATOR_ERROR_DESCRIPTION;
            errorEvent.pageSection = CONFIGURATOR_PAGE_SECTION;
            break;
        }
        return createFrom(ErrorPageEvent, errorEvent);
      })
    );
  }

  protected isSemanticRouteInErrorList(semanticRoute: string, errorList: string[]): boolean {
    return !!errorList.find((elem) => elem === semanticRoute);
  }
}
